import { useMemo } from 'react';

import { fromPromise } from 'xstate';

import { CommunityVerificationProvider } from '@sg/graphql-schema';

import { useVerifyGroupMutation } from '../../../graphql/VerifyGroup.generated';

import type { VerificationResult } from '../../setup';
import type * as Actors from '../../setup/actors';
import type { InputFrom } from 'xstate';

// ─────────────────────────────────────────────────────────────────────────────

export const useVerifyGroupActor = () => {
  const [, verifyGroup] = useVerifyGroupMutation();

  return useMemo(() => {
    return fromPromise<VerificationResult, VerifyGroupInput>(async ({ input }) => {
      const { request, code } = input;

      if (!request) {
        throw new Error('missing_authorization_request');
      }

      if (!code) {
        throw new Error('missing_authorization_code');
      }

      const response = await verifyGroup({
        input: {
          provider: CommunityVerificationProvider.Idme,
          code,
          codeVerifier: request.codeVerifier,
          redirectUri: request.redirectUri,
        },
      });

      if (response.error) {
        throw response.error;
      }

      if (!response.data) {
        throw new Error('missing_verification_result');
      }

      return response.data.verifyGroup;
    });
  }, [verifyGroup]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type VerifyGroupInput = InputFrom<typeof Actors.verifyGroup>;
